export const dummyMaleImages = [
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/amc0jwgl1uo2dlh4ojks",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/xew4vpuahv2989foh03l",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/veodcnovnojrmhj27gm6",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/ykgocl6cdzulubgf89bh",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/white_t_male_i9phmr",
];

export const dummyFemaleImages = [
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/fjke25fvlbpgv9uvvegg",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/zlovls3luuq5xwrlplft",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/iphcdz4zi0s5d6xlazbj",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/df7bcgzpboyzberb1ffe",
  "https://res.cloudinary.com/dxezkqczp/image/upload/f_auto,q_auto/v1/tryons/prod/models/mq2ht9xcogdfxgxlqmbu",
];
